import {
  StandardWidget,
  StandardWidgetOptions,
  TeiaViewer,
  ViewerSignal,
  WidgetContextProviderProps,
  WidgetFactoryFunction,
} from '@stereograph/teiaviewer';
import { usePluginTranslation } from '@translation';
import { AnomalyTabsProvider } from '../context/AnomalyTabsContext';
import { AnomalyWidgetContextProvider } from '../context/AnomalyWidgetContext';
import { TeiaAnomalyResumeWidgetContent } from './TeiaAnomalyResumeWidgetContent';

declare global {
  interface ViewerWidgetRegistry {
    TeiaAnomalyResume: WidgetFactoryFunction<
      TeiaAnomalyResumeWidget,
      {
        projectId: number;
        isAnomalyCreation: boolean;
      } & StandardWidgetOptions
    >;
  }
}

export class TeiaAnomalyResumeWidget extends StandardWidget {
  readonly type = 'TeiaAnomalyResume';
  anomalyId?: number;
  projectId: number;
  isAnomalyCreation: boolean;
  readonly onCreateAnomalySignal = new ViewerSignal();
  readonly onOpenAnomalyListSignal = new ViewerSignal();

  constructor(
    viewer: TeiaViewer,
    projectId: number,
    isAnomalyCreation: boolean,
    options: StandardWidgetOptions = {},
  ) {
    super(viewer, {
      ...options,
      size: 'compact',
      useFooter: false,
      color: 'white',
    });

    this.projectId = projectId;
    this.isAnomalyCreation = isAnomalyCreation;
  }

  override Header = function Header() {
    const { t } = usePluginTranslation();

    return t('anomaly_plugin.resume_widget.title');
  };

  override Content = function Content() {
    return <TeiaAnomalyResumeWidgetContent />;
  };

  protected override ContextProvider = (props: WidgetContextProviderProps) => {
    const { children } = props;

    return (
      <AnomalyWidgetContextProvider
        projectId={this.projectId}
        onAnomalyCreationSignal={this.onCreateAnomalySignal}
        onOpenAnomalyListSignal={this.onOpenAnomalyListSignal}
        {...props}
      >
        <AnomalyTabsProvider isAnomalyCreation={this.isAnomalyCreation}>
          {children}
        </AnomalyTabsProvider>
      </AnomalyWidgetContextProvider>
    );
  };

  override Footer = () => {
    return null;
  };
}
